module.exports = __webpack_public_path__ + "static/media/icon_y.b51dfac6.svg";